import { api } from "./common";
import { Id, ModelFunction } from "../types";
import { fetchOrgEntities } from "./fetch-org-entities";

type Props = { subscriptionId: Id } & Pick<ModelFunction, "id" | "name">;

export const renameModelFunction = async (props: Props) => {
  await api("v2/modelfunctions", {
    method: "POST",
    body: JSON.stringify({ id: props.id, name: props.name }),
    headers: { subscriptionid: props.subscriptionId.toString() },
  });

  const { modelFunctions } = await fetchOrgEntities(props.subscriptionId);

  return { modelFunctions };
};
